import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import Footer from './components/Footer';
import Dashboard from './pages/Dashboard';
import Reports from './pages/Reports';
import LiveTrack from './pages/LiveTrack';
import MapRotate from './pages/MapRotate';
import Geofence from './pages/Geofence';
import Landmarks from './pages/Landmarks';
import Alerts from './pages/Alerts';
import SubUsers from './pages/SubUsers';
import ShareVehicle from './pages/ShareVehicle';
import Vehicles from './pages/Vehicles';
import ContactUs from './pages/ContactUs';
import GpsDevices from './pages/GpsDevices';
import Login from './pages/login';
import './custom.css';
import './styles/Pages.css';
import 'bootstrap/dist/css/bootstrap.min.css';

// Protected route component
const ProtectedRoute = ({ children, isLoggedIn }) => {
  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }
  return children;
};

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [activePage, setActivePage] = useState('Home');

  useEffect(() => {
    // Check if user is already logged in
    const loggedInStatus = localStorage.getItem('isLoggedIn');
    if (loggedInStatus === 'true') {
      setIsLoggedIn(true);
    }
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    // Remove the login status from localStorage
    localStorage.removeItem('isLoggedIn');
    // Update the state
    setIsLoggedIn(false);
  };


  return (
    <Routes>
        <Route path="/login" element={
          isLoggedIn ? <Navigate to="/" /> : <Login onLoginSuccess={handleLoginSuccess} />
        } />
        <Route path="/" element={
          <ProtectedRoute isLoggedIn={isLoggedIn}>
            <div className="d-flex">
              <Sidebar isOpen={sidebarOpen} activePage={activePage} onPageChange={setActivePage} />
              <div className="flex-grow-1 d-flex flex-column vh-100">
                <Topbar toggleSidebar={toggleSidebar} onLogout={handleLogout} />
                <div className="flex-grow-1 bg-light overflow-auto">
                  <Dashboard />
                </div>
                <Footer />
              </div>
            </div>
          </ProtectedRoute>
        } />
        <Route path="/reports" element={
          <ProtectedRoute isLoggedIn={isLoggedIn}>
            <div className="d-flex">
              <Sidebar isOpen={sidebarOpen} activePage={activePage} onPageChange={setActivePage} />
              <div className="flex-grow-1 d-flex flex-column vh-100">
                <Topbar toggleSidebar={toggleSidebar} onLogout={handleLogout} />
                <div className="flex-grow-1 bg-light overflow-auto">
                  <Reports />
                </div>
                <Footer />
              </div>
            </div>
          </ProtectedRoute>
        } />
        <Route path="/live-track" element={
          <ProtectedRoute isLoggedIn={isLoggedIn}>
            <div className="d-flex">
              <Sidebar isOpen={sidebarOpen} activePage={activePage} onPageChange={setActivePage} />
              <div className="flex-grow-1 d-flex flex-column vh-100">
                <Topbar toggleSidebar={toggleSidebar} onLogout={handleLogout} />
                <div className="flex-grow-1 bg-light overflow-auto">
                  <LiveTrack />
                </div>
                <Footer />
              </div>
            </div>
          </ProtectedRoute>
        } />
        <Route path="/map-rotate" element={
          <ProtectedRoute isLoggedIn={isLoggedIn}>
            <div className="d-flex">
              <Sidebar isOpen={sidebarOpen} activePage={activePage} onPageChange={setActivePage} />
              <div className="flex-grow-1 d-flex flex-column vh-100">
                <Topbar toggleSidebar={toggleSidebar} onLogout={handleLogout} />
                <div className="flex-grow-1 bg-light overflow-auto">
                  <MapRotate />
                </div>
                <Footer />
              </div>
            </div>
          </ProtectedRoute>
        } />
        <Route path="/geofence" element={
          <ProtectedRoute isLoggedIn={isLoggedIn}>
            <div className="d-flex">
              <Sidebar isOpen={sidebarOpen} activePage={activePage} onPageChange={setActivePage} />
              <div className="flex-grow-1 d-flex flex-column vh-100">
                <Topbar toggleSidebar={toggleSidebar} onLogout={handleLogout} />
                <div className="flex-grow-1 bg-light overflow-auto">
                  <Geofence />
                </div>
                <Footer />
              </div>
            </div>
          </ProtectedRoute>
        } />
        <Route path="/landmarks" element={
          <ProtectedRoute isLoggedIn={isLoggedIn}>
            <div className="d-flex">
              <Sidebar isOpen={sidebarOpen} activePage={activePage} onPageChange={setActivePage} />
              <div className="flex-grow-1 d-flex flex-column vh-100">
                <Topbar toggleSidebar={toggleSidebar} onLogout={handleLogout} />
                <div className="flex-grow-1 bg-light overflow-auto">
                  <Landmarks />
                </div>
                <Footer />
              </div>
            </div>
          </ProtectedRoute>
        } />
        <Route path="/alerts" element={
          <ProtectedRoute isLoggedIn={isLoggedIn}>
            <div className="d-flex">
              <Sidebar isOpen={sidebarOpen} activePage={activePage} onPageChange={setActivePage} />
              <div className="flex-grow-1 d-flex flex-column vh-100">
                <Topbar toggleSidebar={toggleSidebar} onLogout={handleLogout} />
                <div className="flex-grow-1 bg-light overflow-auto">
                  <Alerts />
                </div>
                <Footer />
              </div>
            </div>
          </ProtectedRoute>
        } />
        <Route path="/sub-users" element={
          <ProtectedRoute isLoggedIn={isLoggedIn}>
            <div className="d-flex">
              <Sidebar isOpen={sidebarOpen} activePage={activePage} onPageChange={setActivePage} />
              <div className="flex-grow-1 d-flex flex-column vh-100">
                <Topbar toggleSidebar={toggleSidebar} onLogout={handleLogout} />
                <div className="flex-grow-1 bg-light overflow-auto">
                  <SubUsers />
                </div>
                <Footer />
              </div>
            </div>
          </ProtectedRoute>
        } />
        <Route path="/share-vehicle" element={
          <ProtectedRoute isLoggedIn={isLoggedIn}>
            <div className="d-flex">
              <Sidebar isOpen={sidebarOpen} activePage={activePage} onPageChange={setActivePage} />
              <div className="flex-grow-1 d-flex flex-column vh-100">
                <Topbar toggleSidebar={toggleSidebar} onLogout={handleLogout} />
                <div className="flex-grow-1 bg-light overflow-auto">
                  <ShareVehicle />
                </div>
                <Footer />
              </div>
            </div>
          </ProtectedRoute>
        } />
        <Route path="/vehicles" element={
          <ProtectedRoute isLoggedIn={isLoggedIn}>
            <div className="d-flex">
              <Sidebar isOpen={sidebarOpen} activePage={activePage} onPageChange={setActivePage} />
              <div className="flex-grow-1 d-flex flex-column vh-100">
                <Topbar toggleSidebar={toggleSidebar} onLogout={handleLogout} />
                <div className="flex-grow-1 bg-light overflow-auto">
                  <Vehicles />
                </div>
                <Footer />
              </div>
            </div>
          </ProtectedRoute>
        } />
        <Route path="/gps-devices" element={
          <ProtectedRoute isLoggedIn={isLoggedIn}>
            <div className="d-flex">
              <Sidebar isOpen={sidebarOpen} activePage={activePage} onPageChange={setActivePage} />
              <div className="flex-grow-1 d-flex flex-column vh-100">
                <Topbar toggleSidebar={toggleSidebar} onLogout={handleLogout} />
                <div className="flex-grow-1 bg-light overflow-auto">
                  <GpsDevices />
                </div>
                <Footer />
              </div>
            </div>
          </ProtectedRoute>
        } />
        <Route path="/contact" element={
          <ProtectedRoute isLoggedIn={isLoggedIn}>
            <div className="d-flex">
              <Sidebar isOpen={sidebarOpen} activePage={activePage} onPageChange={setActivePage} />
              <div className="flex-grow-1 d-flex flex-column vh-100">
                <Topbar toggleSidebar={toggleSidebar} onLogout={handleLogout} />
                <div className="flex-grow-1 bg-light overflow-auto">
                  <ContactUs />
                </div>
                <Footer />
              </div>
            </div>
          </ProtectedRoute>
        } />
      </Routes>
  );
}

export default App;